"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventLogAction = void 0;
var EventLogAction;
(function (EventLogAction) {
    EventLogAction["FAILED_REQUEST"] = "FAILED_REQUEST";
    EventLogAction["USER_CREATE"] = "USER_CREATE";
    EventLogAction["USER_EDIT"] = "USER_EDIT";
    EventLogAction["USER_DESTROY"] = "USER_DESTROY";
    EventLogAction["USER_DELETE"] = "USER_DELETE";
    EventLogAction["USER_REINVITE"] = "USER_REINVITE";
    EventLogAction["USER_FORCE_PASSWORD_RESET"] = "USER_FORCE_PASSWORD_RESET";
    EventLogAction["USER_LOGIN"] = "USER_LOGIN";
    EventLogAction["USER_LOGOUT"] = "USER_LOGOUT";
    EventLogAction["TOKEN_CONFIRM"] = "TOKEN_CONFIRM";
    EventLogAction["API_TOKEN_REGENERATE"] = "API_TOKEN_REGENERATE";
    EventLogAction["API_TOKEN_CREATE"] = "API_TOKEN_CREATE";
    EventLogAction["API_TOKEN_DESTROY"] = "API_TOKEN_DESTROY";
    EventLogAction["ACCOUNT_CREATE"] = "ACCOUNT_CREATE";
    EventLogAction["ACCOUNT_EDIT"] = "ACCOUNT_EDIT";
    EventLogAction["ACCOUNT_DESTROY"] = "ACCOUNT_DESTROY";
    EventLogAction["ACCOUNT_DELETE"] = "ACCOUNT_DELETE";
    EventLogAction["DOMAIN_CREATE"] = "DOMAIN_CREATE";
    EventLogAction["DOMAIN_EDIT"] = "DOMAIN_EDIT";
    EventLogAction["DOMAIN_DESTROY"] = "DOMAIN_DESTROY";
    EventLogAction["DOMAIN_DELETE"] = "DOMAIN_DELETE";
    EventLogAction["DOMAIN_RESET"] = "DOMAIN_RESET";
    EventLogAction["DOMAIN_STATS_RESET"] = "DOMAIN_STATS_RESET";
    EventLogAction["SAVED_REPORT_CREATE"] = "DOMAIN_CREATE";
    EventLogAction["SAVED_REPORT_EDIT"] = "DOMAIN_EDIT";
    EventLogAction["SAVED_REPORT_DESTROY"] = "SAVED_REPORT_DESTROY";
    EventLogAction["SAVED_REPORT_DELETE"] = "SAVED_REPORT_DELETE";
    EventLogAction["SAVED_REPORT_SCHEDULE_CREATE"] = "SAVED_REPORT_SCHEDULE_CREATE";
    EventLogAction["SAVED_REPORT_SCHEDULE_EDIT"] = "SAVED_REPORT_SCHEDULE_EDIT";
    EventLogAction["SAVED_REPORT_SCHEDULE_DESTROY"] = "SAVED_REPORT_SCHEDULE_DESTROY";
    EventLogAction["DOMAIN_INTEGRATION_CREATE"] = "DOMAIN_INTEGRATION_CREATE";
    EventLogAction["DOMAIN_INTEGRATION_EDIT"] = "DOMAIN_INTEGRATION_EDIT";
    EventLogAction["DOMAIN_INTEGRATION_DESTROY"] = "DOMAIN_INTEGRATION_DESTROY";
    EventLogAction["NOTIFICATION_CREATE"] = "NOTIFICATION_CREATE";
    EventLogAction["NOTIFICATION_EDIT"] = "NOTIFICATION_EDIT";
    EventLogAction["NOTIFICATION_DESTROY"] = "NOTIFICATION_DESTROY";
    EventLogAction["NOTIFICATION_DELETE"] = "NOTIFICATION_DELETE";
    EventLogAction["NOTIFICATION_TEST_CREATE"] = "NOTIFICATION_TEST_CREATE";
    EventLogAction["NOTIFICATION_TEST_EDIT"] = "NOTIFICATION_TEST_EDIT";
    EventLogAction["NOTIFICATION_TEST_DESTROY"] = "NOTIFICATION_TEST_DESTROY";
    EventLogAction["NOTIFICATION_TEST_DELETE"] = "NOTIFICATION_TEST_DELETE";
    EventLogAction["NOTIFICATION_TEMPLATE_CREATE"] = "NOTIFICATION_TEMPLATE_CREATE";
    EventLogAction["NOTIFICATION_TEMPLATE_EDIT"] = "NOTIFICATION_TEMPLATE_EDIT";
    EventLogAction["NOTIFICATION_TEMPLATE_DESTROY"] = "NOTIFICATION_TEMPLATE_DESTROY";
    EventLogAction["NOTIFICATION_TEMPLATE_DELETE"] = "NOTIFICATION_TEMPLATE_DELETE";
    EventLogAction["NOTIFICATION_GROUP_CREATE"] = "NOTIFICATION_GROUP_CREATE";
    EventLogAction["NOTIFICATION_GROUP_EDIT"] = "NOTIFICATION_GROUP_EDIT";
    EventLogAction["NOTIFICATION_GROUP_DESTROY"] = "NOTIFICATION_GROUP_DESTROY";
    EventLogAction["NOTIFICATION_GROUP_DELETE"] = "NOTIFICATION_GROUP_DELETE";
    EventLogAction["CAMPAIGN_CREATE"] = "CAMPAIGN_CREATE";
    EventLogAction["CAMPAIGN_EDIT"] = "CAMPAIGN_EDIT";
    EventLogAction["CAMPAIGN_DESTROY"] = "CAMPAIGN_DESTROY";
    EventLogAction["CAMPAIGN_DELETE"] = "CAMPAIGN_DELETE";
    EventLogAction["PROMPT_CREATE"] = "PROMPT_CREATE";
    EventLogAction["PROMPT_EDIT"] = "PROMPT_EDIT";
    EventLogAction["PROMPT_DESTROY"] = "PROMPT_DESTROY";
    EventLogAction["PROMPT_DELETE"] = "PROMPT_DELETE";
    EventLogAction["PROMPT_GROUP_CREATE"] = "PROMPT_GROUP_CREATE";
    EventLogAction["PROMPT_GROUP_EDIT"] = "PROMPT_GROUP_EDIT";
    EventLogAction["PROMPT_GROUP_DESTROY"] = "PROMPT_GROUP_DESTROY";
    EventLogAction["PROMPT_GROUP_DELETE"] = "PROMPT_GROUP_DELETE";
    EventLogAction["SEGMENT_CREATE"] = "SEGMENT_CREATE";
    EventLogAction["SEGMENT_EDIT"] = "SEGMENT_EDIT";
    EventLogAction["SEGMENT_DESTROY"] = "SEGMENT_DESTROY";
    EventLogAction["SEGMENT_DELETE"] = "SEGMENT_DELETE";
    EventLogAction["SEGMENT_GROUP_CREATE"] = "SEGMENT_GROUP_CREATE";
    EventLogAction["SEGMENT_GROUP_EDIT"] = "SEGMENT_GROUP_EDIT";
    EventLogAction["SEGMENT_GROUP_DESTROY"] = "SEGMENT_GROUP_DESTROY";
    EventLogAction["SEGMENT_GROUP_DELETE"] = "SEGMENT_GROUP_DELETE";
    EventLogAction["WHITE_LABEL_CREATE"] = "WHITE_LABEL_CREATE";
    EventLogAction["WHITE_LABEL_EDIT"] = "WHITE_LABEL_EDIT";
    EventLogAction["WHITE_LABEL_DESTROY"] = "WHITE_LABEL_DESTROY";
    EventLogAction["WHITE_LABEL_DELETE"] = "WHITE_LABEL_DELETE";
    EventLogAction["PLATFORM_MESSAGE_CREATE"] = "PLATFORM_MESSAGE_CREATE";
    EventLogAction["PLATFORM_MESSAGE_EDIT"] = "PLATFORM_MESSAGE_EDIT";
    EventLogAction["PLATFORM_MESSAGE_DESTROY"] = "PLATFORM_MESSAGE_DESTROY";
    EventLogAction["PLATFORM_MESSAGE_DELETE"] = "PLATFORM_MESSAGE_DELETE";
    EventLogAction["FEED_UPDATE"] = "DOMAIN_FEED_UPDATE";
    EventLogAction["FEED_DESTROY"] = "DOMAIN_FEED_DESTROY";
    EventLogAction["FLAG_CREATE"] = "FLAG_CREATE";
    EventLogAction["FLAG_EDIT"] = "FLAG_EDIT";
    EventLogAction["FLAG_DESTROY"] = "FLAG_DESTROY";
    EventLogAction["FLAG_DELETE"] = "FLAG_DELETE";
})(EventLogAction = exports.EventLogAction || (exports.EventLogAction = {}));
//# sourceMappingURL=event-log-action.js.map